import React from "react";

import { useIntl } from "react-intl";

import * as S from "./DeleteEnvWithIntegration.style";
import * as StatusSettings from "./StatusSettings.style";

import type { Environment, Project } from "@packages/client";

interface DeleteEnvWithIntegrationProps {
  environment: Environment;
  integrationTypes: string;
  project?: Project;
}

export const DeleteEnvWithIntegration = ({
  environment,
  integrationTypes,
  project
}: DeleteEnvWithIntegrationProps) => {
  const intl = useIntl();
  return (
    <>
      <S.DeleteEnvBodyText size="small">
        {intl.formatMessage(
          {
            id: "status_active_delete_description.integration"
          },
          {
            integration: integrationTypes
          }
        )}
      </S.DeleteEnvBodyText>
      <S.StatusSettingBodyText size="small">
        {intl.formatMessage({ id: "delete_branch_link_cli" })}
      </S.StatusSettingBodyText>

      <StatusSettings.CodeBlock
        singleLine
        isCopyable
        id="platform_delete_env_cmd.integration"
      >
        {intl.formatMessage(
          { id: "platform_delete_env_cmd.integration" },
          { repository: project?.repository.url, envName: environment.name }
        )}
      </StatusSettings.CodeBlock>
    </>
  );
};
